import { Box, styled } from "@mui/material";

import { Typography } from "@/modules/common/components/Typography";
import { PlayBox } from "@/modules/play/Components";
import { AchievementCard } from "@/modules/play/Components/AchievementCard";
import { useAchievements } from "@/modules/play/context/hooks/player/useAchievements";
import { useTranslation } from "@/modules/translations";

export { SynthesisAchievementsTab };

function SynthesisAchievementsTab() {
  const { t } = useTranslation();
  const { unlockedAchievements } = useAchievements();

  return (
    <PlayBox display="flex" flexDirection="column" gap={4}>
      <Typography>
        {t("synthesis.player.achievements-section.description")}
      </Typography>
      <CardContainer>
        {unlockedAchievements.map((achievementName) => (
          <Box key={achievementName} display="flex" justifyContent="center">
            <AchievementCard achievementName={achievementName} />
          </Box>
        ))}
      </CardContainer>
    </PlayBox>
  );
}

const CardContainer = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(3),
  justifyContent: "center",
  [theme.breakpoints.down("lg")]: {
    gridTemplateColumns: "1fr",
  },
}));
